export default "__VITE_ASSET__952cfa39__"